import React from 'react';
import { FormattedMessage } from 'react-intl';

import { colors, fontSize } from 'styles/cp';

const AffirmBnplDisclaimer: React.FC = () => (
  <div className="affirm-bnpl-disclaimer">
    <FormattedMessage
      id="AFFIRM_BNPL_BOTTOM_DISCLAIMER"
      defaultMessage="Unless prompted for a registered business name at application, Affirm loans are primarily for personal, family, or household use only."
    />
    <style jsx>{`
      .affirm-bnpl-disclaimer {
        font-family: AvenirNextforINTUIT-Regular;
        font-size: ${fontSize.xxs};
        color: ${colors.ghostGray};
        text-align: center;
        line-height: 1.33;
        margin-top: 24px;
        margin-bottom: 10px;
      }
    `}</style>
  </div>
);

export default AffirmBnplDisclaimer;
